import { render, staticRenderFns } from "./formasPagamentos.vue?vue&type=template&id=ca9899f0"
import script from "./formasPagamentos.vue?vue&type=script&lang=js"
export * from "./formasPagamentos.vue?vue&type=script&lang=js"
import style0 from "./formasPagamentos.vue?vue&type=style&index=0&id=ca9899f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports